import { PlaceBet } from 'shared/interface';
import { isAndroid, isAndroidNewApp, isIOSApp, isMobile, isPWA, RegistrationMethodCode } from 'shared/util/utility';
import { BetSlipConditions, Freebet } from '../interface/offers.interface';

const getRegistrationMethodCode = (): RegistrationMethodCode => {
	if (isAndroidNewApp) {
		return RegistrationMethodCode.ANDROID_APP;
	}
	if (isPWA() && isAndroid) {
		return RegistrationMethodCode.ANDROID_APP;
	}
	if (isMobile() && isIOSApp) {
		return RegistrationMethodCode.IOS_APP;
	}
	if (isMobile()) {
		return RegistrationMethodCode.MOBILE_BROWSER;
	}

	return RegistrationMethodCode.WEB_BROWSER;
};

const checkOutcomeAllInEventTypesCondition = (betSlipConditions: BetSlipConditions, betsOutcomes: PlaceBet[]) => {
	const allowed = betSlipConditions?.outcomeAllInEventTypes || [];
	return !allowed.length || betsOutcomes.every((betsOutcome) => allowed.includes(betsOutcome.eventType));
};

const checkOutcomeAllInGameTypesCondition = (betSlipConditions: BetSlipConditions, betsOutcomes: PlaceBet[]) => {
	const allowed = betSlipConditions?.outcomeAllInGameTypes || [];
	return !allowed.length || betsOutcomes.every((betsOutcome) => allowed.includes(betsOutcome.gameType as number));
};

const checkOutcomeNoneInGameTypesCondition = (betSlipConditions: BetSlipConditions, betsOutcomes: PlaceBet[]) => {
	const notAllowed = betSlipConditions?.outcomeNoneInGameTypes || [];
	return !notAllowed.length || betsOutcomes.every((betsOutcome) => !notAllowed.includes(betsOutcome.gameType as number));
};

const checkOutcomeOneInEventTypesCondition = (betSlipConditions: BetSlipConditions, betsOutcomes: PlaceBet[]) => {
	const allowed = betSlipConditions?.outcomeOneInEventTypes || [];
	return !allowed.length || betsOutcomes.some((betsOutcome) => allowed.includes(betsOutcome.eventType));
};

const checkOutcomeOneInGameTypesCondition = (betSlipConditions: BetSlipConditions, betsOutcomes: PlaceBet[]) => {
	const allowed = betSlipConditions?.outcomeOneInGameTypes || [];
	return !allowed.length || betsOutcomes.some((betsOutcome) => allowed.includes(betsOutcome.gameType as number));
};

const checkSlipRegisterMethodsCondition = (betSlipConditions: BetSlipConditions) => {
	const allowedRegisterMethods = betSlipConditions?.slipRegisterMethods || [];
	const currentMode = getRegistrationMethodCode();
	return !allowedRegisterMethods.length || allowedRegisterMethods.includes(currentMode);
};

export const filterFreebets = (freebets: Freebet[] = [], betsOutcomes: PlaceBet[] = []) => {
	if (!betsOutcomes.length) {
		return [];
	}

	return freebets.filter(({ betSlipConditions }) =>
		[
			checkOutcomeAllInEventTypesCondition(betSlipConditions, betsOutcomes),
			checkOutcomeOneInEventTypesCondition(betSlipConditions, betsOutcomes),
			checkOutcomeNoneInGameTypesCondition(betSlipConditions, betsOutcomes),
			checkOutcomeAllInGameTypesCondition(betSlipConditions, betsOutcomes),
			checkOutcomeOneInGameTypesCondition(betSlipConditions, betsOutcomes),
			checkSlipRegisterMethodsCondition(betSlipConditions),
		].every(Boolean),
	);
};
